import React from "react";
import { ArrowUpRight, ArrowDownRight } from "lucide-react";

export const StatCard = ({ label, value, delta, icon: Icon, accent = false, suffix, testId }) => {
  const positive = typeof delta === "string" ? !delta.startsWith("-") : (delta ?? 0) >= 0;
  return (
    <div
      data-testid={testId}
      className="card-surface card-hover relative p-5 overflow-hidden"
    >
      {accent && (
        <div className="absolute top-0 left-0 right-0 h-[1px]"
             style={{ background: "linear-gradient(90deg, transparent, var(--brand), transparent)" }} />
      )}
      <div className="flex items-start justify-between">
        <span className="eyebrow">{label}</span>
        {Icon && (
          <div className="w-8 h-8 rounded-md flex items-center justify-center"
               style={{ background: "rgba(59,130,246,0.08)", border: "1px solid rgba(59,130,246,0.2)" }}>
            <Icon size={15} style={{ color: "var(--brand)" }} />
          </div>
        )}
      </div>
      <div className="mt-4 flex items-end justify-between">
        <div className="font-display text-3xl font-medium tabular-nums" style={{ color: "var(--text)" }}>
          {value}{suffix && <span className="text-lg ml-0.5" style={{ color: "var(--text-dim)" }}>{suffix}</span>}
        </div>
        {delta !== undefined && delta !== null && (
          <div className={`flex items-center gap-1 text-xs font-mono ${positive ? "text-emerald-500" : "text-rose-500"}`}>
            {positive ? <ArrowUpRight size={12}/> : <ArrowDownRight size={12}/>}
            {delta}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
